/**
 * @module app.kya.list.ChooseAgentCtrl
 *
 */
define(['angular'], function(angular) {


    function ChooseAgentCtrl($scope, $uibModalInstance, $location, agentService, $log) {
        let self = {};

        self.stores = [];
        self.isSearchLoading = false;
        self.searchedAgent = null;
        self.hasBeenSearched = false;

        self.selectedFilter = '1';
        self.storeFilters = [
            { state: '', label: 'Tout' },
            { state: 0, label: 'Pré-client' },
            { state: 1, label: 'Client' },
            { state: 2, label: 'Ancien client' },
            { state: 3, label: 'Prospect' },
            { state: 4, label: 'Ancien Propriétaire' },
            { state: 5, label: 'Attente Reprise' }
        ];

        self.modalOk = function(store) {
            $uibModalInstance.close({
                store: store
            });
        };

        self.modalCancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Search clients according to a research
         */
        self.searchAgent = function searchAgent() {
            if (!self.searchedAgent || self.searchedAgent === '') {
                return;
            }
            self.isSearchLoading = true;
            self.hasBeenSearched = true;

            agentService
                .searchAgent(self.searchedAgent)
                .then(function(stores) {
                    self.stores = stores;
                    self.stores.map(function(store) {
                        store.agents = store.agents.filter(agent => {return agent.isRfcAgent})
                    });
                })
                .catch(function(err) {
                    $log.error(err);
                })
                .finally(function() {
                    self.isSearchLoading = false;
                });
        };

        return self;
    }

    ChooseAgentCtrl.$inject = ['$scope', '$uibModalInstance', '$location', 'agentService', '$log'];

    angular
        .module('app.kya.list.chooseAgentCtrl', ['ui.bootstrap.modal'])
        .controller('ChooseAgentCtrl', ChooseAgentCtrl);
});
